/* BS · Live variant prices inside page content (7 Oct 2026).
   Markup: <span data-bs-vp="unibrau|10G · 120V">$1,825</span>  (handle|exact English variant title; no title = lowest price, shown as "from").
   Prices come from sections/bs-vp-price.liquid via the Section Rendering API, so they match the shopper's
   market and currency (e.g. "$2,399 CAD" on brausupply.ca). Falls back to /products/<handle>.js.
   Put these inside a [data-bs-live] element so bs-fx.js does not convert them a second time. */
(function () {
  function fmt(cents, cur) {
    var v = cents / 100;
    var s = v.toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return '$' + s + (cur && cur !== 'USD' ? ' ' + cur : '');
  }
  function viaSection(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=bs-vp-price', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (t) {
        var m = t.match(/<script[^>]*data-bs-vp-data[^>]*>([\s\S]*?)<\/script>/);
        if (!m) throw 0;
        var d = JSON.parse(m[1]);
        return { cur: d.c, min: d.p, variants: d.v.map(function (x) { return { title: x.t, price: x.p }; }) };
      });
  }
  function viaJs(handle) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { return { cur: cur, min: p.price_min, variants: p.variants.map(function (x) { return { title: x.title, price: x.price }; }) }; });
  }
  function run() {
    var els = [].slice.call(document.querySelectorAll('[data-bs-vp]'));
    if (!els.length) return;
    var fr = (document.documentElement.lang || '').slice(0, 2) === 'fr';
    var by = {};
    els.forEach(function (el) {
      var parts = el.getAttribute('data-bs-vp').split('|');
      var h = parts[0].trim();
      (by[h] = by[h] || []).push({ el: el, want: (parts[1] || '').trim().toLowerCase() });
    });
    Object.keys(by).forEach(function (h) {
      viaSection(h).catch(function () { return viaJs(h); }).then(function (d) {
        by[h].forEach(function (o) {
          var v = null;
          if (o.want) for (var i = 0; i < d.variants.length; i++) if (d.variants[i].title.trim().toLowerCase() === o.want) { v = d.variants[i]; break; }
          var cents = v ? v.price : d.min;
          if (cents > 0) o.el.textContent = (v ? '' : (fr ? 'dès ' : 'from ')) + fmt(cents, d.cur);
        });
      }).catch(function () {});
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
})();
